import { createApp } from 'vue'

import App from './App.vue'

import router from './router'
import store from './store'
import i18n from './utils/i18n'

import { axiosHelper } from './helpers/axios'
import authHelper from './helpers/auth'

import clickout from './directives/clickoutside'

const app = createApp(App)

app.use(axiosHelper, {
  apiUrl: process.env.VUE_APP_API_URL,
  store
})
app.use(router)
app.use(authHelper, {
  store,
  router
})

app.directive('clickout', clickout)


app.use(store)
app.use(i18n)

app.mount('#app')